import React, { lazy } from "react";

import { useAppContext } from "../../contexts/AppContext";
import { Switch } from "../core/Switch";

const InnerChatSettings = lazy(() => import("../Chat/InnerChatSettings"));

export const ChatSettings = () => {
  const { loadChat, setLoadChat } = useAppContext();

  return (
    <div className="flex flex-col p-2">
      <header className="flex flex-col gap-2">
        <div className="flex items-center gap-2">
          <Switch
            isSelected={loadChat || false}
            onValueChange={(bool: boolean) => {
              setLoadChat(bool);
            }}
          />
          <h2 className="text-xl">Chat</h2>
        </div>
        <p className="text-default-600 text-xs">
          Chat with other canvas users
        </p>
      </header>
      <section>
        <React.Suspense>
          {loadChat && (
            <div className="mt-4">
              <InnerChatSettings />
            </div>
          )}
        </React.Suspense>
      </section>
    </div>
  );
};
